import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "width", "primary", "secondary", "color", "style"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { ChildrenPropType, StylePropType } from '../../../../services/proptypes';
import GridColumnFlex from '../../../GridColumnFlex';
var defaultProps = {
  children: null,
  color: 'transparent',
  primary: false,
  secondary: false,
  width: null,
  style: {}
};
function Color(_ref) {
  var children = _ref.children,
    width = _ref.width,
    primary = _ref.primary,
    secondary = _ref.secondary,
    color = _ref.color,
    style = _ref.style,
    columnProps = _objectWithoutProperties(_ref, _excluded);
  var extraClasses = '';
  if (primary) {
    extraClasses = ' primary';
  } else if (secondary) {
    extraClasses = ' secondary';
  }
  var styles = primary || secondary ? {} : {
    backgroundColor: color
  };
  return /*#__PURE__*/React.createElement(GridColumnFlex, _extends({
    className: "color-component".concat(extraClasses),
    width: width,
    style: _objectSpread(_objectSpread({}, styles), style)
  }, columnProps), children);
}
Color.defaultProps = defaultProps;
export default Color;